var map = {
	"./certificate_automatic_frame.png": 216,
	"./certificate_ects_frame.png": 217,
	"./certificate_frame.png": 218,
	"./certificate_verified_frame.png": 219,
	"./frame_blue_de.png": 220,
	"./frame_blue_en.png": 221,
	"./frame_gold_de.png": 222,
	"./frame_gold_en.png": 223,
	"./frame_green_de.png": 224,
	"./frame_green_en.png": 225,
	"./generic_audit_sample.jpg": 226,
	"./generic_bundle_sample.jpg": 227,
	"./generic_coa_ects_sample.jpg": 228,
	"./generic_coa_sample.jpg": 229,
	"./generic_sop_sample.jpg": 230,
	"./milestone_completed.png": 231,
	"./milestone_completed.svg": 232,
	"./milestone_completed_small.svg": 233,
	"./milestone_uncompleted.png": 234,
	"./milestone_uncompleted.svg": 235,
	"./milestone_uncompleted_old.png": 236
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 215;